import { apiFetch } from '../lib/api';

export type DiscordLinkStatus = {
  enabled: boolean;
  guildId?: string | null;
  publicInviteUrl?: string | null;
  connected: boolean;
  link?: {
    discordUserId: string;
    username: string;
    displayName: string;
    avatarUrl?: string | null;
    linkedAt?: string | null;
    lastSyncedAt?: string | null;
    guildJoined?: boolean;
  } | null;
};

export type DiscordOrgSpace = {
  enabled: boolean;
  linked: boolean;
  publicInviteUrl?: string | null;
  guildId?: string | null;
  orgId?: string | null;
  eligible: boolean;
  channel?: {
    channelId: string;
    channelName: string;
    status: string;
    channelUrl: string;
  } | null;
};

export async function fetchDiscordLinkStatus() {
  return apiFetch<DiscordLinkStatus>('/api/discord/me');
}

export async function fetchDiscordOrgSpace(orgId?: string) {
  const query = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return apiFetch<DiscordOrgSpace>(`/api/discord/org-space${query}`);
}

export async function requestDiscordAuthorizeUrl(redirectPath = '/dashboard/profile') {
  const query = `?redirectPath=${encodeURIComponent(redirectPath)}`;
  return apiFetch<{ enabled: boolean; authorizeUrl: string }>(
    `/api/discord/oauth/start${query}`,
  );
}

export async function unlinkDiscordAccount() {
  return apiFetch<{ ok: boolean; unlinked: boolean }>('/api/discord/me/unlink', {
    method: 'POST',
  });
}

export async function syncDiscordAccess(orgId?: string) {
  return apiFetch<{ ok: boolean; scope: 'user' | 'organization'; result: unknown }>(
    '/api/discord/sync',
    {
      method: 'POST',
      body: JSON.stringify(orgId ? { orgId } : {}),
    },
  );
}
